import type { EffectiveVisibility } from '@apuestapr/contracts';
import { Badge, type BadgeProps, type BadgeShape } from '@apuestapr/ui';
import type { ReactElement } from 'react';

interface VisibilityPresentation {
  readonly label: string;
  readonly symbol: string;
  readonly shape: BadgeShape;
  readonly variant: NonNullable<BadgeProps['variant']>;
}

export const visibilityPresentations = {
  live: { label: 'Visible', symbol: '✓', shape: 'circle', variant: 'accent' },
  scheduled: { label: 'Programado', symbol: '◷', shape: 'diamond', variant: 'outline' },
  expired: { label: 'Expirado', symbol: '⌛', shape: 'square', variant: 'destructive' },
  draft: { label: 'Borrador', symbol: '✎', shape: 'circle', variant: 'neutral' },
  archived: { label: 'Archivado', symbol: '▣', shape: 'diamond', variant: 'destructive' },
} as const satisfies Record<EffectiveVisibility, VisibilityPresentation>;

/** Uses only the effective visibility supplied by the API; no browser clock participates. */
export const VisibilityBadge = ({
  visibility,
}: {
  readonly visibility: EffectiveVisibility;
}): ReactElement => {
  const presentation = visibilityPresentations[visibility];
  return (
    <Badge
      data-visibility={visibility}
      icon={<span>{presentation.symbol}</span>}
      shape={presentation.shape}
      variant={presentation.variant}
    >
      {presentation.label}
    </Badge>
  );
};
